


export default class {
    constructor($el) {
        this.$ = $el;
        this.row = [];
        this.current = null; /* row.i */
        $el.find('.-row').each((i, el)=>{
            let row = new AccordionGalleryRow($(el), i, this);
            this.row.push(row);
        });
    }
    open(cell, row) {

    }
    closeCurrent(newCurrentRow = null, newCurrentCell = null) {
        if (this.current === null) {
            return false;
        }
        if (this.current !== newCurrentRow.i) {
            // console.log('closeCurrent(newCurrentRow, newCurrentCell)', newCurrentRow.i, newCurrentCell.i);
            this.row[this.current].closeCurrent(newCurrentRow, newCurrentCell);
            if (newCurrentRow === null) {
                this.current = null;
            } else {
                this.current = newCurrentRow.i;
            }
        }
    }
}



class AccordionGalleryRow {
    constructor($el, i, master) {
        this.$ = $el;
        this.i = i;
        this.master = master;
        this.$expander = master.$.find('.-for-line-'+i);
        this.$expanderHeight = this.$expander.find('.-height');
        this.$content = this.$expanderHeight.find('.-content');
        this.cells = [];
        this.current = null; /* cell.i */
        $el.find('.-cell').each((i, el)=>{
            let cell = new AccordionGalleryCell($(el), i, this);
            this.cells.push(cell);
        });
    }
    open(cell) {
        this.$content.html(cell.data.content).prepend($('<h3>').text(cell.data.title));
        setTimeout(()=>{
            this.expand();
        }, 10);
        this.master.closeCurrent(this, cell);
        if (this.master.current === this.i) {
            this.closeCurrent(this, cell);
            // console.log('open', this.current, cell.i);
            if (cell.i !== this.current) {
                if (this.current !== null) {
                    this.cells[this.current].close(false);
                }
                this.current = cell.i;
            }
        } else {
            if (this.master.current !== null) {
                this.master.rows[this.master.current].closeCurrent(this, cell);
            }
            this.master.current = this.i;
        }
        this.current = cell.i;
        // console.log('setting row current to', this.current);
    }
    closeCurrent(newCurrentRow = null, newCurrentCell = null) {
        if (newCurrentRow === null || newCurrentRow.i !== this.i) {
            // console.log('closeCurrent()', this.i);
            // console.log('this.current (cell.i)', this.current);
            // console.log('newCurrentCell.i', newCurrentCell.i);
            // console.log('newCurrentRow.i', newCurrentRow.i);
            if (this.current !== null &&
                (
                    newCurrentRow === null || newCurrentRow.i !== this.i
                    || newCurrentCell === null || newCurrentCell.i !== this.current
                )
            ) {
                this.cells[this.current].close(false);
            }
            this.closeExpander();
        }
    }
    expand() {
        let height = this.$expanderHeight.outerHeight();
        this.$expander.css('height', height+'px');
    }
    closeExpander() {
        this.current = null;
        this.master.current = null;
        this.$expander.css('height', 0);
    }
}


class AccordionGalleryCell {
    constructor($el, i, master) {
        this.$ = $el;
        this.i = i;
        this.master = master;
        this.data = $el.data('expand');
        this.isOpen = false;
        $el.click(()=>{
            this.click();
        });
    }
    click() {
        if (this.isOpen) {
            this.close(true);
        } else {
            this.open();
        }
    }
    open() {
        this.isOpen = true;
        this.$.addClass('-current');
        this.master.open(this);
    }
    close(closeExpander = false) {
        this.isOpen = false;
        this.$.removeClass('-current');
        if (closeExpander) {
            // console.log('closeExpander() called from cell');
            this.master.closeExpander();
        }
    }
}







// WEBPACK FOOTER //
// ./scripts/lib/AccordionGallery.js